import {
    DATAMASTER_GET_EXCEL_LATEST_UPDATES_BEGIN,
    DATAMASTER_GET_EXCEL_LATEST_UPDATES_SUCCESS,
    DATAMASTER_GET_EXCEL_LATEST_UPDATES_FAILURE
  } from './constants';

import { BFFAgent } from 'BFFAgent';
  
  export function getExcelLatestUpdates() {
    return async dispatch =>{
        dispatch({
            type:DATAMASTER_GET_EXCEL_LATEST_UPDATES_BEGIN,
        })
        try {
            await BFFAgent.Datamasters.getExcelLatestUpdates()
            dispatch({
                type:DATAMASTER_GET_EXCEL_LATEST_UPDATES_SUCCESS
            })
        } catch (error) {
            dispatch({
                type:DATAMASTER_GET_EXCEL_LATEST_UPDATES_FAILURE,
            })
        }
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case DATAMASTER_GET_EXCEL_LATEST_UPDATES_BEGIN:
        return {
          ...state,
          loadingExcelLatestUpdates:true
        };
      case DATAMASTER_GET_EXCEL_LATEST_UPDATES_SUCCESS:
        return{
            ...state,
            loadingExcelLatestUpdates:false
        }
      case DATAMASTER_GET_EXCEL_LATEST_UPDATES_FAILURE:
        return{
            ...state,
            loadingExcelLatestUpdates:false,
            errorExcelLatestUpdates:true
        }
  
      default:
        return state;
    }
  }
  